export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) {
    const { GeolocationStore } = stores()
    const event = useRequestEvent()
    GeolocationStore.value = event?.context.geolocation
  }
})
